import { FormControl, NG_VALIDATORS } from '@angular/forms';
import { Directive, Input } from '@angular/core';

@Directive({
    selector: '[floRange]',
    providers: [
        { provide: NG_VALIDATORS, useExisting: RangeDirective, multi: true },
    ],
})
export class RangeDirective {
    private formControl: FormControl;
    private _floRange: string;

    /**
     * Range input should be comma separated
     * Example: [floRange]="10,100"
     */
    @Input()
    set floRange(value: string) {
        if (this.formControl &&
            this._floRange !== value) {
            // If the value is changing force a validation check
            this._floRange = value;
            this.formControl.updateValueAndValidity();
        } else {
            this._floRange = value;
        }
    }

    get floRange(): string {
        return this._floRange;
    }

    public validate(control: FormControl): { [s: string]: boolean } {
        this.formControl = control;

        if (control.value !== '0' &&
            control.value !== 0 &&
            !control.value) {
            return null;
        }

        const numValue: number = parseFloat(control.value);
        if (isNaN(numValue)) {
            return { invalid: true };
        }

        const min: number = this.getMin();
        const max: number = this.getMax();

        if (min &&
            numValue < min) {
            return { invalid: true };
        }

        if (max &&
            numValue > max) {
            return { invalid: true };
        }

        return null;
    }

    private getMin(): number {
        if (!this.floRange) {
            return null;
        }

        const commaIdx: number = this.floRange.indexOf(',');

        if (commaIdx > 0) {
            return <number><any> this.floRange.split(',')[0];
        }

        return <number><any> this.floRange;
    }

    private getMax(): number {
        if (!this.floRange) {
            return null;
        }

        const commaIdx: number = this.floRange.indexOf(',');

        if (commaIdx > 0) {
            return <number><any> this.floRange.split(',')[1];
        }

        return <number><any> this.floRange;
    }
}
